var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWideLineMiddle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 182,
    viewBox: "0 0 1920 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1920.5 81.7671C1503.22 316.416 913.039 69.1939 714.5 10.5C520 -47 327 174.5 98 128C59.423 120.167 27.2169 110.637 -0.408569 100.5",
    stroke: "#BFB098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWideLineMiddle);
export default __webpack_public_path__ + "static/media/wide-line-middle.89dff8a8cd13d269ac30ec7294380b65.svg";
export { ForwardRef as ReactComponent };